

export const lastPathGuard = (to, from, next) => {
    localStorage.setItem('lastPath', from.name)
    next()
}
